import { PropertyInfo } from './PropertyInfo';
import { PropertyInfoModalContainer } from './style';

import type { ComponentProps } from 'react';
import type React from 'react';

type Props = {
  children: PropertyInfoProps[];
};

type PropertyInfoProps = ComponentProps<typeof PropertyInfo>;

export const PropertyInfoPopup: React.FC<Props> = ({ children }: Props) => {
  return <PropertyInfoModalContainer>{children.map(PropertyInfo)}</PropertyInfoModalContainer>;
};
